const service = document.querySelector("#produto_servico");
const manteiga = document.querySelector("#qtde_pao_c_manteiga");
const pre_mus = document.querySelector("#qtde_pao_c_presunto_mussarela");
var total = "";

if (document.querySelector("#qtde_desjejum")) {
  total = document.querySelector("#qtde_desjejum");
} else if (document.querySelector("#qtde_cafe_tarde")) {
  total = document.querySelector("#qtde_cafe_tarde");
}

if (service && (service.value == 50 || service.value == 51)) {
  if (manteiga) {
    manteiga.addEventListener("change", (e) => {
      if (pre_mus && parseInt(pre_mus.value) > 0)
        total.value = parseInt(pre_mus.value) + parseInt(manteiga.value);
      else total.value = parseInt(manteiga.value);
    });
  }

  if (pre_mus) {
    pre_mus.addEventListener("change", (e) => {
      if (manteiga && parseInt(manteiga.value) > 0)
        total.value = parseInt(manteiga.value) + parseInt(pre_mus.value);
      else total.value = parseInt(pre_mus.value);
    });
  }
}
